const AUTH_SESSION_CHANNEL_NAME = 'populate:auth-session';
const AUTH_SESSION_LOGGED_OUT = 'logged_out';
type AuthSessionSignal = typeof AUTH_SESSION_LOGGED_OUT;

let authSessionChannel: BroadcastChannel | null | undefined;

function getAuthSessionChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') {
    authSessionChannel = null;
  } else if (typeof authSessionChannel === 'undefined') {
    authSessionChannel = new BroadcastChannel(AUTH_SESSION_CHANNEL_NAME);
  }

  return authSessionChannel ?? null;
}

function isLoggedOutSignal(value: unknown): value is AuthSessionSignal {
  return value === AUTH_SESSION_LOGGED_OUT;
}

export function emitAuthSessionLoggedOut() {
  getAuthSessionChannel()?.postMessage(AUTH_SESSION_LOGGED_OUT);
}

export function subscribeToAuthSessionLoggedOut(
  onLoggedOut: () => void,
) {
  const channel = getAuthSessionChannel();
  const onMessage = (event: MessageEvent<unknown>) => {
    if (isLoggedOutSignal(event.data)) {
      // We use replace here to avoid the user being able to go back to the previous page after logging out
      // Temporarily commented out to avoid redirecting the user to the session-ended page when they log out in another tab
      // onLoggedOut();
    }
  };

  channel?.addEventListener('message', onMessage);

  return () => {
    channel?.removeEventListener('message', onMessage);
  };
}
